// extracted by mini-css-extract-plugin
export default {"menu":"Course_menu__5fks+","nav":"Course_nav__ZALg4"};